import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "about",
  class: "about section"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row align-items-xl-center gy-5" }
const _hoisted_4 = { class: "col-xl-5 content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[1] || (_cache[1] = _createElementVNode("h3", null, "A propos", -1)),
          _cache[2] || (_cache[2] = _createElementVNode("h2", null, "Comment faire les paiements en ligne grâce à E-SOGEMA", -1)),
          _cache[3] || (_cache[3] = _createElementVNode("p", null, "Payez vos loyer et vos dettes pour bénéficier d'un avantage certain dans les nouveaux marchés du Bénin.", -1)),
          _createVNode(_component_router_link, {
            to: "/e-processus",
            class: "read-more"
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createElementVNode("span", null, "Payer", -1),
              _createElementVNode("i", { class: "bi bi-arrow-right" }, null, -1)
            ]))]),
            _: 1
          })
        ]),
        _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"col-xl-7\"><div class=\"row gy-4 icon-boxes\"><div class=\"col-md-6\"><div class=\"icon-box\"><i class=\"bi bi-buildings\"></i><h3>Identification </h3><p>Retrouver votre emplacement et découvrer exactement ce que vous devez auprès de la SOGEMA</p></div></div><div class=\"col-md-6\"><div class=\"icon-box\"><i class=\"bi bi-clipboard-pulse\"></i><h3>Choix des impayés</h3><p>Choississez les impayés que vous désirez payer et passez à l&#39;étape suivante</p></div></div><div class=\"col-md-6\" data-aos-delay=\"400\"><div class=\"icon-box\"><i class=\"bi bi-command\"></i><h3>Procéder au paiement </h3><p>Valider le paiement en ligne avec un agrégateur de votre choix</p></div></div><div class=\"col-md-6\" data-aos-delay=\"500\"><div class=\"icon-box\"><i class=\"bi bi-graph-up-arrow\"></i><h3>Obtenez un reçu de paiement</h3><p>Recevez un reçu de paiement pour confirmer que votre paiement a été encaissé. Vous devrez bien concerver ce reçu</p></div></div></div></div>", 1))
      ])
    ])
  ]))
}